import { loginByPhone } from "@/api/login";
import { loginByPhoneAndCode, whoami } from "../../api/login";
import { getMessageFromLast, getGroupMessageFromLast } from "@/api/chat";
import Vue from "vue";

const emptyState = {
  tempFriendId: null,
  tempFriendInfo: null,
  tempGroupInfo: null,
  chat: [],
  group: [],
  sort: {},
  isNotify: false,
};
/**
 * 用于本机缓存聊天内容
 */
const msgContent = {
  state: {
    tempFriendId: null,
    /**
     * friendId,
     * friendName,
     * msg(最近一条消息),
     * unreadMessages(未读消息数量),
     * friendAvatar(头像)
     */
    tempFriendInfo: null,
    tempGroupInfo: null,
    /**
     * 存放有聊天内容或新消息的好友信息，按最新一条消息排序
     * 方法：
     * 1.socket链接时，初始化此列表
     * 2.收到消息时，更新此列表
     */
    chat: [
      // {
      //   friendId: ,
      //   friendName: ,
      //   friendAvatar: , // 好友头像
      //   unreadMessages: , // 未读消息数量
      //   lastMsgTime: , // 最近一条消息的时间
      //   lastMsg: , // 最近一条消息内容
      // }
    ],
    group: [
      // 群聊信息
    ],
    sort: {
      /**
       * friendId: {}
       */
    },

    /**
     * friendId: [
     *    {
     *
     *    }
     * ]
     */
    //弹窗通知
    isNotify: false,
  },

  mutations: {
    /**
     * 收到一条消息
     * 工作内容：
     * 1.检查该消息发送者下是否有消息。若有，则存入消息列表；若无，则创建（已完成）
     * 2.检测是否有与该好友的聊天窗口。若有，更新最新消息情况并重新排序；若无，则创建
     * @param {s} state
     * @param {*} data
     */
    recive: (state, data) => {
      let { acceptUserId, sendUserId, friendId } = data;
      console.log("send: ", data);
      // let myId = store.state.user.id;
      // let friendId = myId == sendUserId ? acceptUserId : sendUserId

      state[friendId] ? state[friendId].push(data) : (state[friendId] = [data]);
    },
    reciveGroup: (state, data) => {
      let { groupId } = data;
      console.log("reciveGroup: ", data);
      state["g" + groupId]
        ? state["g" + groupId].push(data)
        : (state["g" + groupId] = [data]);
    },
    /**
     * 将一条已通过ws发送的消息，存入 列表
     * 发送一条消息（已完成）
     * @param {*} state
     * @param {*} data
     */
    send: (state, data) => {
      let { acceptUserId } = data;
      state[acceptUserId]
        ? state[acceptUserId].push(data)
        : (state[acceptUserId] = [data]);
      console.log("send------", state[acceptUserId]);
    },

    addChatMessage(state, { key, value }) {
      Vue.set(state, key, value);
    },
    initGroupMsg: (state, info) => {
      let data = { ...info, start: 0 };
      console.log("state[groupId]", state["g" + info.groupId], data);
      if (state["g" + info.groupId] == undefined) {
        getGroupMessageFromLast(data)
          .then((response) => {
            console.log("getGroupMessageFromLast", response, info.callback);
            if (info.callback) {
              info.callback(response.rows);
            }
          })
          .catch((error) => {
            console.error("搜索消息出错:", error);
          });
      }
    },
    initFriendMsg: (state, info) => {
      let data = { ...info, start: 0 };
      console.log("state[friendId]", state[info.friendId], data);
      if (state[info.friendId] == undefined) {
        getMessageFromLast(data)
          .then((response) => {
            console.log("getMessageFromLast", response.data, info.callback);
            /**
             * TODO 这里赋值没有生效，可能的原因有两个
             * 1.我新添加了一个属性进去，添加进去时页面已经渲染
             * 2.我需要触发一下
             *
             */
            // state[info.friendId] = response.data;

            // state = {...state, 17: response.data}
            // console.log("initFriendMsg: (state, info)", state)
            // this.$store.state.msgContent[this.$store.state.msgContent.tempFriendInfo.friendId] = data
            if (info.callback) {
              info.callback(response.data);
            }
          })
          .catch((error) => {
            console.error("搜索消息出错:", error);
          });
      }
    },
    initChatList: (state, info) => {
      console.log("initChatList", info);
      console.log(state);
    },
    UPDATE_MSG_STATE(state, { key, value }) {
      Vue.set(state, key, value);
    },
    RESET_ISNOTIFY: (state, ok) => {
      state.isNotify = ok;
    },
    CLEAR_MESSAGE_DATA: (state) => {
      Object.assign(state, emptyState);
    },
  },

  getters: {
    msgContent: (state) => {
      return {
        chat: state.chat,
        isNotify: state.isNotify,
      };
    },
  },

  actions: {
    updateMsgProfile({ commit }, payload) {
      commit("UPDATE_MSG_STATE", payload);
    },
    setIsNotify({ commit }, ok) {
      commit("RESET_ISNOTIFY", ok);
    },
  },
};

export default msgContent;
